import { BaseApiClient } from '../BaseApiClient'

export class ApiClient extends BaseApiClient {
  static getPdfBrowserUrl (application) {
    return this.getUrl(`pdf/browser?id=${application.id}&access-token=${this.getAccessToken()}`, true)
  }

  static async getPass (applicationId, visitorId, transportId = null, isGivePassPeriod = false) {
    const data = {
      applicationId: applicationId,
      visitorId: visitorId,
      transportId: transportId,
      isGivePassPeriod: isGivePassPeriod
    }

    return this.post('pdf/pass', data, {
      headers: this.getAuthHeaders(),
      responseType: 'blob'
    })
  }

  static async getPasses (applicationId, isGivePassPeriod = false) {
    const data = {
      applicationId: applicationId,
      isGivePassPeriod: isGivePassPeriod
    }

    return this.post('pdf/passes', data, {
      headers: this.getAuthHeaders(),
      responseType: 'blob'
    })
  }

  static getBulletinUrl () {
    return this.getUrl('pdf/app-bulletin', true)
  }

  static getApplicationScreenUrl (search = null) {
    const path = search ? `vue/application/list?search=${search}` : 'vue/application/list?'

    return this.getUrl(path, true)
  }

  static getApplicationArchiveUrl (search = null) {
    const path = search ? `vue/application/list?archived=1&search=${search}` : 'vue/application/list?archived=1'

    return this.getUrl(path, true)
  }

  static getAdminPanelScreenUrl () {
    return this.getUrl('backend/black-list', true)
  }

  static getUsersScreenUrl () {
    return this.getUrl('backend/user', true)
  }

  static async login (data) {
    return this.post('auth/login', data)
  }

  static async loginNoPassword (data) {
    return this.post('auth/login/no-password', data)
  }

  static async acceptLogin (data) {
    return this.post('auth/login/accept', data)
  }

  static async logout () {
    await this.backendLogout()

    return this.get('auth/logout', {
      headers: this.getAuthHeaders()
    })
  }

  static async userMe () {
    return this.get('user/me', {
      headers: this.getAuthHeaders()
    })
  }

  static async userPermissions () {
    return this.get('user/permissions', {
      headers: this.getAuthHeaders()
    })
  }

  static async checkAccess () {
    return this.get('user/check-access', {
      headers: this.getAuthHeaders()
    })
  }

  static async checkCurrentVisitorApplications (data) {
    return this.post('application-services/check-current-visitor-applications', data, {
      headers: this.getAuthHeaders()
    })
  }

  static async checkBlacklist (personalId) {
    const data = {
      personal_id: personalId
    }

    return this.post('application-services/check-blacklist', data, {
      headers: this.getAuthHeaders()
    })
  }

  static async checkBlacklistVisitors (personalId) {
    const data = {
      personal_id: personalId
    }

    return this.post('application-services/check-blacklist-visitors', data, {
      headers: this.getAuthHeaders()
    })
  }

  static async checkBlacklistByApplications (applicationIds) {
    const data = {
      application_ids: applicationIds
    }

    return this.post('application-services/check-blacklist-by-applications', data, {
      headers: this.getAuthHeaders()
    })
  }

  static async removeUploadedDocument (data) {
    return this.post('upload/remove', data, {
      headers: this.getAuthHeaders()
    })
  }

  static async getUploadDocuments (params) {
    return this.get('upload/get-docs', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static async getTransportDocuments (params) {
    return this.get('upload/get-transports-docs', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static async getApplicationDocuments (params) {
    return this.get('upload/get-application-docs', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static async getLatestApplicationOrganizationDoc (params) {
    return this.get('upload/get-latest-application-organization-doc', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static async createApplication (data) {
    return this.post('application-services/create-application', data, {
      headers: this.getAuthHeaders()
    })
  }

  static async editApplication (data) {
    return this.post('application-services/edit-application', data, {
      headers: this.getAuthHeaders()
    })
  }

  static async approveApplication (data) {
    return this.post('application-services/approve-application', data, {
      headers: this.getAuthHeaders()
    })
  }

  static async changeVisitorAccess (data) {
    return this.post('visitors/change-access', data, {
      headers: this.getAuthHeaders()
    })
  }

  static async changeTransportAccess (data) {
    return this.post('visitors/change-transport-access', data, {
      headers: this.getAuthHeaders()
    })
  }

  static async importVisitorsFromFile (formData) {
    return this.post('application-services/import-visitors-from-file', formData, {
      headers: this.getAuthHeaders()
    })
  }

  static async applicationData (params) {
    return this.get('application-data', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static async vesselsData (params) {
    return this.get('vessels-data', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static async configurationData (params) {
    return this.get('configuration-data', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static async cfgMenuData (params) {
    return this.get('cfg-menu', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static async cfgMenuDataApplicationMenu (params) {
    return this.get('cfg-menu/menu', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static async deleteApplication (id) {
    return this.delete('application/delete', {
      data: { id },
      headers: this.getAuthHeaders()
    }).then(response => response.data)
  }

  static async nationalityMaskData (params) {
    return this.get('nationality-document-mask-data', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static async transportPlateMaskData (params) {
    return this.get('transport-plate-mask-data', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static async extraApplicationData (params) {
    return this.get('application-data/extra-data', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static async changeFlagByVesselName (params) {
    return this.post('application-data/change-flag-by-vessel-name', params, {
      headers: this.getAuthHeaders()
    })
  }

  static async otherData (params) {
    return this.get('other-data', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static async issuePass (params) {
    return this.post('pass/give-pass', params, {
      headers: this.getAuthHeaders()
    })
  }

  static async mainHeaderData (params) {
    return this.get('other-data/main-header', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static async identificationPlaces (code) {
    return this.get('application-data/visitor-code', {
      params: {
        code
      },
      headers: this.getAuthHeaders()
    })
  }

  static async validateTransportNumber (number) {
    const data = { number }

    return this.post('application-services/validate-transport-number', data, {
      headers: this.getAuthHeaders()
    })
  }

  static async checkOrganizationInn (data) {
    return this.post('application-services/check-organization-inn', data, {
      headers: this.getAuthHeaders()
    })
  }

  static async sendSupport (data) {
    return this.post('user-services/support', data, {
      headers: this.getAuthHeaders()
    })
  }

  static async updateStatus(applicationId, data) {
    return this.post(`application-status/update?id=${applicationId}`, data, {
      headers: this.getAuthHeaders()
    })
  }

  static getTimeOfWork () {
    return this.get('application-data/time-of-work', {
      headers: this.getAuthHeaders()
    })
  }

  static getTerminalOrganization () {
    return this.get('organization-data/terminal-organization', {
      headers: ApiClient.getAuthHeaders()
    })
  }

  static getSignerStepOneUrl (application) {
    return this.getUrl(`application/step-one?id=${application.id}&access-token=${this.getAccessToken()}`)
  }

  static getSignerStepTwoUrl (application) {
    return this.getUrl(`application/step-two?id=${application.id}&access-token=${this.getAccessToken()}`)
  }

  static getGuardScreenUrl () {
    return this.getUrl('guard', true)
  }

  static getAccountUrl () {
    return this.getUrl('profile/account', true)
  }

  static uploadAvatar (data) {
    return this.post('upload/upload-avatar', data, {
      headers: this.getAuthHeaders()
    })
  }

  static logFrontendError (data) {
    return this.post('logger/index', data, {
      headers: this.getAuthHeaders()
    })
  }

  static sendToScud (data) {
    return this.post('xml/scud-xml', data, {
      headers: this.getAuthHeaders()
    })
  }

  static async sendVisitorToSolvo(data) {
    return this.post('xml/solvo-visitor-xml', data, {
      headers: this.getAuthHeaders()
    })
  }

  static async sendApplicationToScud(data) {
    return this.post('xml/application-scud-xml', data, {
      headers: this.getAuthHeaders()
    })
  }

  static async acceptDateOfExpireRequest(data) {
    return this.post('document-check/accept-date-of-expire', data, {
      headers: this.getAuthHeaders()
    })
  }

  static async cancelDateOfExpireRequest(data) {
    return this.post('document-check/cancel-date-of-expire', data, {
      headers: this.getAuthHeaders()
    })
  }

  static async addInternalCommentRequest(data) {
    return this.post('application-services/add-internal-comment', data, {
      headers: this.getAuthHeaders()
    })
  }
}
